import React, { useState, useEffect } from 'react';
import { Container } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import {
  clearActiveProvider,
  fetchActiveProvider,
} from '../../../actions/providers';
import ErrorSnackBar from '../../shared/ErrorSnackBar';
import { clearErrorMessage } from '../../../actions/errorMessage';
import LoadingMask from '../../shared/LoadingMask';
import PhysicalProviderForm from './PhysicalProviderForm';
import GCPProviderProviderForm from './GCPProviderForm';
import PROVIDER_TYPES from '../providerTypes';
import { useLocation } from 'react-router';
import AWSProviderForm from './AWSProviderForm';
import AzureProviderForm from './AzureProviderForm';

export default function ProviderForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { provider_uuid } = useParams();
  const location = useLocation();
  const sp = new URLSearchParams(location.search);
  const provider = useSelector((state) => state.provider);
  const api_error = useSelector((state) => state.errorMessage);

  const type = provider?.type || sp.get('type');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!provider && provider_uuid) {
      dispatch(fetchActiveProvider(provider_uuid));
    } else {
      setLoading(false);
    }
  }, [dispatch, provider_uuid, provider]);

  useEffect(() => {
    return () => {
      dispatch(clearErrorMessage());
      dispatch(clearActiveProvider());
    };
  }, [dispatch]);

  if (loading) {
    return <LoadingMask />;
  }

  switch (type) {
    case PROVIDER_TYPES.PHYSICAL.value:
      return (
        <Container>
          <PhysicalProviderForm provider={provider} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.GCP.value:
      return (
        <Container>
          <GCPProviderProviderForm provider={provider} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.AWS.value:
      return (
        <Container>
          <AWSProviderForm provider={provider} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.AZURE.value:
      return (
        <Container>
          <AzureProviderForm provider={provider} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    default:
      navigate('/resources');
      return <div>Redirecting...</div>;
  }
}
